export interface ProgramQualityRating {
  phaseRatings: ProgramPhaseRating;
}

export const ProgramPhaseRatingAttributeNames = [
  "phaseChange",
  "activity",
  "pauses",
] as const;
export type ProgramPhaseRatingAttribute = typeof ProgramPhaseRatingAttributeNames[number];

export type ProgramPhaseRating = {
  [Attribute in string]: Ratings;
};

interface Ratings {
  ratings: Rating;
}

type Rating = {
  [Attribute in ProgramPhaseRatingAttribute]: number | null;
};
